"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.775 7.345c-.753 0-1.375.618-1.375 1.396v6.519c0 .777.622 1.395 1.375 1.395h7.262c.754 0 1.375-.618 1.375-1.395V8.74c0-.778-.621-1.396-1.375-1.396zm10.038 2.163V8.74c0-1.538-1.236-2.796-2.776-2.796H5.776A2.786 2.786 0 0 0 3 8.741v6.519c0 1.537 1.236 2.795 2.775 2.795h7.262c1.54 0 2.775-1.258 2.775-2.795v-.767l2.359 1.916c1.147.933 2.829.097 2.829-1.359v-6.1c0-1.455-1.682-2.292-2.83-1.359zm0 1.804v1.377l3.24 2.634c.211.17.547.031.547-.273v-6.1a.336.336 0 0 0-.546-.273z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=VideoIcon24.js.map